const modules = require.context('./modules', false, /\.js$/);
const keys = modules.keys();

/**
 * 批量自动化注册指令
 */
export default {
  install(Vue) {
    keys.forEach(key => {
      const name = key.replace(/(.*\/)*([^.]+).*/gi, '$2');
      Vue.directive(name, modules(key).default);
    });
  }
};
